
export default {
  methods: {
    $confirmAlert(title, text, func, color, acceptText = 'نعم', cancelText = 'لا'){
      this.$vs.dialog({
        type: 'confirm',
        color: color ? color : 'danger',
        acceptText: acceptText,
        cancelText: cancelText,
        title: title ? title : `تأكيد`,
        text: text,
        accept: func,
      })
    }
  }
}

